import { Typography } from "@mui/material"
import { useSchedule } from "../lib/useSchedule"

export function ScheduleAuditLabel({ payload, id }) {
    const isDerived = Boolean(payload?.originatingScheduleId)
    const originSchedule = useSchedule(payload?.originatingScheduleId) || null
    return isDerived ? (
        <Typography variant={"body2"} id={`derivedFrom-${id}`} fontSize="13px" fontWeight="500">
            Derived from:{" "}
            <Typography variant={"body2"} component="span" fontSize="13px">
                {originSchedule?.schedule?.title} #{payload?.originatingScheduleCode}
            </Typography>
        </Typography>
    ) : null
}
